import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_DOCENTES = 'ALL_DOCENTES';
export const ALL_BLOQUES_HORAS_DOCENTES = 'ALL_BLOQUES_HORAS_DOCENTES';
export const ACTIVO_DOCENTES = 'ACTIVO_DOCENTES';
export const LOADING_ALL_DOCENTES = 'LOADING_ALL_DOCENTES';
export const PARAMS_DOCENTES = 'PARAMS_DOCENTES';
export const SELECTS_DOCENTES = 'SELECTS_DOCENTES';

const initialState = {
  all: [],
  allBloquesHoras: [],
  activo: null,
  loadingAll: false,
  params: {},
  selects: [],
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 60,
    totalItems: 1,
    totalPages: 1,
  },
};

export const docentesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_DOCENTES:
      return {
        ...state,
        all: action.payload.data.sort((a, b) =>
          a.usuario.perfil.pnombre.localeCompare(b.usuario.perfil.pnombre),
        ),
        pagination: action.payload.meta,
      };
    case ALL_BLOQUES_HORAS_DOCENTES:
      return {
        ...state,
        allBloquesHoras: action.payload.data,
      };
    case ACTIVO_DOCENTES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_DOCENTES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_DOCENTES:
      return {
        ...state,
        params: action.payload,
      };
    case SELECTS_DOCENTES:
      return {
        ...state,
        selects: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
